// Service: algoDashboard.js
// Purpose: API methods for the Algo Trading dashboard

import api from '../../services/api';

const AlgoDashboardService = {
  /**
   * List all deployments for the current user
   * @param {boolean} includeStopped - Include stopped deployments
   * @param {number} days - How far back for stopped deployments
   * @returns {Promise} { deployments: [...], total: N }
   */
  getUserDeployments: async (includeStopped = false, days = 1) => {
    return api.get('/deployments/user', {
      params: { include_stopped: includeStopped, days },
    });
  },

  /**
   * Batch fetch positions, performance, and open order counts from OMS
   * @param {string[]} strategyInstanceIds - List of strategy_instance_ids
   * @returns {Promise} Keyed by strategy_instance_id
   */
  getAlgoSummary: async (strategyInstanceIds) => {
    return api.post('/algo/summary', {
      strategy_instance_ids: strategyInstanceIds,
    });
  },
};

export default AlgoDashboardService;
